import { Autocomplete, Box, Grid } from "@mui/material"
import { CstmTextField } from "../../../../../core/global/forms/CstmTextField"
import { Generate } from "./Generate"
import { ToolContext } from "../../../../../core/context/ToolContext"
import { useContext } from "react"

export const Thead = ({inputChangeHandler}) => {
    
    const {report_state, setup_state, global_component_state} = useContext(ToolContext)
    const {form} = report_state
    const { branchData, toolUser } = setup_state
    const {snackBarLoader} = global_component_state
    // console.log(toolUser.data[0]);
    return (
        <Box minHeight="170px" display="flex" flexDirection="column" justifyContent="center" gap={1.5}>
            <Box width="100%" display="flex" alignItems="center" gap={3} bgcolor="#FFFFFF" borderRadius="12px" p={2}>
                <Box width="100%" id="walkthrough-branch-sales-report-step-1">
                    <Autocomplete
                        fullWidth
                        options={branchData.data}
                        getOptionLabel={(option) => option.name || ""}
                        onChange={(e, value) => inputChangeHandler(e, value, 'branch_id')}
                        value={form.data.branch_id === ''? null: branchData.data.find((f) => f.id === form.data.branch_id) || null}
                        renderOption={(props, option) => (
                            <li {...props} key={option.id}>
                                {option.name}
                            </li>
                        )}
                        renderInput={(params) => (
                        <CstmTextField {...params} label="Branch" placeholder="Branch" />
                        )}
                    />
                </Box>
                <Box width="100%" id="walkthrough-branch-sales-report-step-2">
                    <Autocomplete   
                        fullWidth
                        options={toolUser.data}
                        getOptionLabel={(option) => (option.first_name +' '+ option.last_name)}
                        key={option => option.id}
                        onChange={(e, value) => inputChangeHandler(e, value, 'user_id')}
                        value={ form.data.user_id === '' ? null : toolUser.data.find((f) => f.id === form.data.user_id) || null} 
                        renderOption={(props, option) => {
                            return (
                                <li {...props} key={option.id}>
                                    {option.first_name +' '+ option.last_name}
                                </li>
                            );
                        }}
                        renderInput={(params) => (
                            <CstmTextField {...params} label="User" placeholder="User" />
                        )}
                        // error={!form.data.user_id}
                    />
                </Box>
                <CstmTextField id="walkthrough-branch-sales-report-step-3" fullWidth type="date" variant="outlined" label="Date From" name="from" InputLabelProps={{shrink: true}} 
                InputProps={{ inputProps: { max:"9999-12-31"}}} onInput={(e) => inputChangeHandler(e)} value={form.data.from} error={snackBarLoader.data && form.data.from === ''}/>
                <CstmTextField id="walkthrough-branch-sales-report-step-4" fullWidth type="date" variant="outlined" label="Date To" name="to" InputLabelProps={{shrink: true}} InputProps={{inputProps: {min: form.data.from, max:"9999-12-31"}}} onInput={(e) => inputChangeHandler(e)} value={form.data.to} error={((snackBarLoader.data && form.data.to === '') || (form.data.to < form.data.from))}/>
                <Generate />
            </Box>
            <Grid container direction="row" sx={{py:2, px:4, bgcolor:'#EBEBEB', borderRadius:'10px'}}>
                <Grid item xs={2}>Branch</Grid>
                <Grid item xs={2}>User</Grid>
                <Grid item xs={2} textAlign="center">Date</Grid>
                <Grid item xs={2} textAlign="center">Total Sales</Grid>
                <Grid item xs={2} textAlign="center">Adjusted Total Sales</Grid>
                <Grid item xs={1} textAlign="center">Actual Sales</Grid>
                <Grid item xs={1} textAlign="center">Variance</Grid>
            </Grid>
        </Box>
    )
}